import { render, staticRenderFns } from "./TicketSold.vue?vue&type=template&id=293d0b4e"
import script from "./TicketSold.vue?vue&type=script&lang=js"
export * from "./TicketSold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports